var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"body"},[_c('div',[_c('themed-table',{attrs:{"headers":this.bedManagerService.jobs.headers,"data":_vm.transformedData,"pagination":{
            perPage: this.bedManagerService.jobs.query.limit,
            total: this.bedManagerService.jobs.total,
            page: Math.floor(this.bedManagerService.jobs.query.skip / this.bedManagerService.jobs.query.limit) + 1
        },"sorting":{
          type: this.bedManagerService.jobs.query.sortProperty === 'devices.tasks.status' ? 'status' : this.bedManagerService.jobs.query.sortProperty || 'created',
          direction: this.bedManagerService.jobs.query.sortDirection || 'desc'
        },"sortingEnabled":true,"filteringEnabled":false,"paginationEnabled":this.bedManagerService.jobs.total > this.bedManagerService.jobs.query.limit,"tenantSelected":_vm.currentTenant,"version":_vm.version,"addItem":{ label: 'Job', element: _vm.CreateJobs },"refreshEnabled":true},on:{"paginationChange":(event) => {
            this.bedManagerService.jobs.query.skip = this.bedManagerService.jobs.query.limit * (event.page - 1);
            this.bedManagerService.jobs.query = {...this.bedManagerService.jobs.query};
        },"searchChange":(event) => {
          const query = this.bedManagerService.jobs.query;
          query.skip = 0; // Resets skip as the search params change
          let newTenant = null;
          Object.keys(event).forEach((key) => {
            const customHandlers = ['scope', 'deviceCount', 'taskType', 'packageId', 'status'];
            if (!customHandlers.includes(key) && event[key]) query[key] = typeof event[key] === 'string' ? event[key].trim() : event[key];
            else if (key === 'taskType' && event[key]) query[key] = event[key].reduce((accumulator, item) => {
                accumulator.push(item.value);
                return accumulator;
              }, []);
            else if (key === 'scope' && event[key] && this.bedManagerService.tenants.selected !== event[key]) newTenant = event[key];
            else if (key === 'deviceCount' && event[key]) query['deviceId'] = typeof event[key] === 'string' ? event[key].trim() : event[key];
            else if (key === 'packageId' && event[key]) query['packageId'] =  event[key].map(item => item.value).join();
            else if (key === 'status' && Array.isArray(event[key])) {
              if (event[key].length) {
                query['status'] = event[key].map(item => item.value).join(',');
              } else {
                delete query['status'];
              }
            }
            else delete query[key];
          })
          if (newTenant !== null) {
            Object.keys(query).forEach((prop) => this.bedManagerService.jobs.query[prop] = query[prop]);
            this.bedManagerService.tenants.selected = newTenant;
            if (!newTenant) {
              this.bedManagerService.devices.data = [];
              this.bedManagerService.devices.total = 0;
              this.bedManagerService.jobs.data = [];
              this.bedManagerService.jobs.total = 0;
            }
          } else {
            this.bedManagerService.jobs.query = {...query};
          }
        },"tenantChange":(event) => {
          this.bedManagerService.tenants.selected = event;
          if (!event) {
            this.bedManagerService.devices.data = [];
              this.bedManagerService.devices.total = 0;
              this.bedManagerService.jobs.data = [];
              this.bedManagerService.jobs.total = 0;
          }
        },"sortingChange":(event) => {
          if (event === 'delete') {
            delete this.bedManagerService.jobs.query.sortProperty;
            delete this.bedManagerService.jobs.query.sortDirection;
            this.bedManagerService.jobs.query = { ...this.bedManagerService.jobs.query };
          } else if (event.type === 'status') {
            this.bedManagerService.jobs.query = { ...this.bedManagerService.jobs.query, sortProperty: 'devices.tasks.status', sortDirection: event.direction };
          } else {
            this.bedManagerService.jobs.query = { ...this.bedManagerService.jobs.query, sortProperty: event.type, sortDirection: event.direction };
          }
        },"rowClick":(event) => {
          _vm.setJob(event);
        },"refresh":function($event){return _vm.bedManagerService.fetchJobs()}}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }